import { useState, useEffect } from "react";
import Axios from "axios";
import { useBaseUrl } from "../ApiContext";

const useMonthlyAccess = (userToken) => {
  const baseUrl = useBaseUrl();
  const [exercises, setExercises] = useState([]);
  const [diets, setDiets] = useState([]);

  useEffect(() => {
    const fetchAccess = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/report/monthly/access`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        setExercises(response.data.exercise);
        setDiets(response.data.diet);
      } catch (error) {
        console.log("Error during geting monthly report", error);
      }
    };
    if (userToken) {
      fetchAccess();
    }
  }, [baseUrl, userToken]);
  return { exercises, diets };
};

export default useMonthlyAccess;
